<template>
  <v-flex class="py-3 px-3" xs12 sm11 lg10>
    <v-card class="elevation-2">
      <v-toolbar class="elevation-0 transparent">
        <v-toolbar-title class="headline">Hi {{user.displayName}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-layout row wrap justify-center>
        <v-flex class="px-3" xs12>
          <r-crumbs></r-crumbs>
        </v-flex>
        <v-flex class="px-2 pb-2" xs12 md10>
          <v-layout class="pt-2" row wrap justify-center>
            <v-flex v-if="loading" class="text-xs-center py-5 my-5" xs12>
              <v-progress-circular color="accent" indeterminate></v-progress-circular>
            </v-flex>
            <v-flex v-else v-for="l in links" :key="l.name" class="px-3 pb-4" xs12 sm6>
              <v-card 
                style="cursor: pointer"
                @mouseover="l.cursor = true"
                @mouseout="l.cursor = false"
                @click.native="navigate(l.url)"
                class="pa-2 elevation-1 grey lighten-4">
                <v-layout row wrap justify-center>
                  <v-flex class="text-xs-center" xs12>
                    <v-icon :class="l.cursor ? 'display-3 primary--text' : 'display-3'">{{l.icon}}</v-icon>
                  </v-flex>
                  <v-flex class="pb-2 text-xs-center" xs12>
                    <span :class="l.cursor ? 'title primary--text' : 'title grey--text text--darken-1'"><b>{{l.name}}</b></span>
                  </v-flex>
                  <v-flex class="pb-2 text-xs-center" xs12>
                    <div class="body-2">{{l.description}}</div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: true,
    activeTab: null,
    links: [
      {name: 'Course Content', icon: 'class', url: '/content', cursor: false, description: 'Manage content that are added into courses'},
      {name: 'Questions', icon: 'notes', url: '/questions', cursor: false, description: 'Manage all test questions in the system'},
      {name: 'Manage Courses', icon: 'library_books', url: '/manage-courses', cursor: false, description: 'Manage course schedules and bundles for students to buy'},
      {name: 'Progress', icon: 'bar_chart', url: '/progress', cursor: false, description: 'View student progress and grades in each course'},
      {name: 'Payments', icon: 'monetization_on', url: '/payments', cursor: false, description: 'View list of payments made in the system'},
      {name: 'All Users', icon: 'people', url: '/users', cursor: false, description: 'Manage all existing users in the system'}
    ]
  }),
  beforeMount () {
    this.load()
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    lastLogin () {
      let date = new Date(this.user.lastLogin)
      return date.toLocaleString()
    }
  },
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) {
        if (this.$store.getters.user.type.toLowerCase() === 'admin') {
          this.loading = false
        } else {
          appMsg.msg = 'You are not allowed to view that page'
          this.$store.dispatch('showAppMsg', appMsg)
          this.$router.push('/')
        }
      } else {
        appMsg.msg = 'Please sign in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/sign-in')
      }
    },
    navigate (url) {
      this.$router.push(url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue